import * as Yup from 'yup';
import { imageValidation, isValidExperienceFormat } from '../utils/common';
import { JobModes } from '../constants/common';

export const addEditJobSchema = Yup.object({
  jobTitle: Yup.string()
    .required('Job Title is required')
    .min(3, 'Job Title must be at least 3 characters long'),
  position: Yup.string()
    .required('Position is required')
    .min(3, 'Position must be at least 3 characters long'),
  technologies: Yup.array()
    .of(Yup.string('Should be of type string.'))
    .min(1, 'Please select at least one technology.')
    .required('Technology is required.'),
  jobImage: Yup.mixed()
    .test('format', 'Only the following formats are accepted: .png, .jpg, .jpeg', (value) => {
      if (!value) {
        return true;
      }
      if (typeof value === 'string') {
        return true;
      } else return imageValidation(value);
    })
    .test('fileSize', 'The image size must be less than 1 MB', (value) => {
      if (!value) {
        return true;
      }
      if (typeof value === 'string') {
        return true;
      } else return value.size <= 1024 * 1024; // Check if file size is less than 1 MB.
    })
    .required('Job Logo is required.'),
  skills: Yup.array()
    .of(Yup.string('Should be of type string.'))
    .min(1, 'Please select at least one skill.')
    .required('Skills are required.'),
  jobDescription: Yup.string().trim().required('Job Description is required'),
  jobMode: Yup.string()
    .required('Job Mode is required.')
    .oneOf(
      JobModes.map((mode) => mode.code),
      'Valid Job Mode is required.'
    ),
  experience: Yup.number()
    .typeError('Min Experience must be a valid number.')
    .required('Min Experience is required.')
    .min(0, 'Min Experience must be at least 0.')
    .max(100, 'Min Experience cannot exceed 100 years.')
    .test('valid-format', 'Invalid format. Ensure months do not exceed 11.', (value) =>
      isValidExperienceFormat(value)
    )
    .nullable(),
  maxExperience: Yup.number()
    .typeError('Max Experience must be a valid number.')
    .required('Max Experience is required.')
    .min(0, 'Max Experience must be at least 0.')
    .max(100, 'Max Experience cannot exceed 100 years.')
    .test('valid-format', 'Invalid format. Ensure months do not exceed 11.', (value) =>
      isValidExperienceFormat(value)
    )
    .test(
      'min-max-check',
      'Max Experience must be greater than or equal to Min Experience.',
      function (value) {
        const { experience } = this.parent;
        if (
          value === null ||
          value === undefined ||
          experience === null ||
          experience === undefined
        ) {
          return true;
        }
        return Number(value) >= Number(experience);
      }
    )
    .nullable()
});
